import { mapState, mapGetters, mapActions } from 'vuex';

//import TrackerButton from '@/components/TrackerButton.vue';
//import WayFindBar from '@/components/WayFindBar.vue';
import ToolBar from '@/components/ToolBar.vue';
import Footer from '@/components/Footer.vue';
import Spinner from '@/components/Spinner.vue';
import ImgModal from '@/views/QA/Question/components/ImgModal.vue';

import { LOADING_MESSAGE } from './Career.constants';

export default {
  name: 'Career',

  components: {
    //WayFindBar,
    ToolBar,
    Footer,
    //TrackerButton,
    Spinner,
    ImgModal,
  },

  data() {
    return {
      loadingMessage: LOADING_MESSAGE,

      srcModalImg: '',
    };
  },

  computed: {
    ...mapState('Career', {
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters('Career', {
      mg_plan: 'plan',
    }),
  },

  methods: {
    ...mapActions('Career', {
      ma_getWebTreePlan: 'getWebTreePlan',
    }),

    goBack() {
      this.$router.go(-1);
    },

    handleClickBtn(buttonLink) {
      if (buttonLink) {
        if (-1 !== buttonLink.indexOf('https://class.pzacademy.com')) {
          let link = buttonLink.replace('https://class.pzacademy.com', '');
          this.$router.push(link);
        } else {
          window.open(buttonLink, '_blank');
        }
      }
    },

    showModalImg(item) {
      if (4 === item.itemCertificationStatus) {
        this.srcModalImg = item.itemCertificationPath;
      } else {
        this.srcModalImg = item.itemDemoCertificationPath;
      }
      this.$refs.ImgModal.show();
    },

    async getWebTreePlan() {
      await this.ma_getWebTreePlan({
        planId: this.$route.params.planId,
      });
    },
  },

  created() {
    this.getWebTreePlan();
  },
};
